import React, { Suspense } from 'react'
import { Outlet } from 'react-router'
import { ApolloProvider } from '@apollo/client'

import { IntlProvider } from '@divvy-web/i18n'
import { ToastProvider } from '@divvy-web/skylab.toast'

import client from './apollo/ApolloClient'
import { AuthProvider } from './auth'
import FallbackSpinner from './components/FallbackSpinner'
import PageErrorBoundary from './components/PageErrorBoundary'
import Root from './components/Root'
import ThemeProvider from './components/theme-provider'
import { ExperimentTrackingProvider } from './experiments'
import { WebTrackingProvider } from './tracking/WebTrackingContext'

const AppProvider = () => {
  return (
    <IntlProvider
      locale='en'
      textComponent='span'
    >
      <ThemeProvider>
        <ToastProvider>
          <ApolloProvider client={client}>
            <AuthProvider>
              <WebTrackingProvider>
                <ExperimentTrackingProvider>
                  <Root>
                    <PageErrorBoundary>
                      <Suspense fallback={<FallbackSpinner fullPage />}>
                        <Outlet />
                      </Suspense>
                    </PageErrorBoundary>
                  </Root>
                </ExperimentTrackingProvider>
              </WebTrackingProvider>
            </AuthProvider>
          </ApolloProvider>
        </ToastProvider>
      </ThemeProvider>
    </IntlProvider>
  )
}

export default AppProvider
